export default __webpack_public_path__ + "static/img-point-third-29b012e6d0cc650e488e775bb92766c6.png";